module.exports = __webpack_public_path__ + "img/labour.f961b8fc.jpg";